module.exports = __webpack_public_path__ + "img/59_18.1cc9a97e.png";